import type {
    ProductTaggingSearchResult,
    TagDataUseToCreateTag,
} from '../type';

export const convertSearchResultToTagType = (
    data: ProductTaggingSearchResult
): TagDataUseToCreateTag => {
    if (data.pType === 'Product') {
        return {
            product: {
                id: data.id,
                title: data.title,
                link: data.link,
                professional: data.professional,
                professionalLink: data.professionalLink,
                imageUrl: data.thumb,
                tileImageUrl: data.tileImage,
            },
        };
    }

    return {
        professionalForUnknownProduct: {
            id: data.id,
            title: data.title,
            link: data.link,
        },
        titleForUnknownProfessional: data.title,
    };
};
